"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import { FlexibleCardLayoutSection as FlexibleCardLayoutSectionType } from "@/types/dto/flexible-card-layout-section";

export interface FlexibleCardLayoutProps {
  section: FlexibleCardLayoutSectionType;
}

const LazyLoadFlexibleCardLayout = ({ section }: FlexibleCardLayoutProps) => 

    <GenericLazyLoader
      importComponent={() => import("./flexible-card-layout")}
      componentProps={{ section }}
      debugName="Flexible Card Layout"
      threshold={0.1}
      rootMargin="200px 0px"
    />;


export default LazyLoadFlexibleCardLayout;